import { SHOPS_DETAIL_MARKETING_PAGE } from "@constants/external-routes";
import { SWAGMAGIC } from "@stadium/ui/src/components/brands/all/constants";

import { canonicalizeMySpacePath, removeTrailingSlash } from "@stadium/helpers/routes";
import { DEFAULT_BYO_SHOP_CODE } from "@stadium/constants/shop";
import { DEFAULT_WORKSPACE_SLUG, getAQuote, MY_WORKSPACE_SLUG } from "@stadium/constants";

import {
  oldStoreBasePathWithoutCountryCode,
  oldCreateStoreBasePathWithoutCountryCode,
  oldStoreAccessDenied,
  oldStoreBasePath,
  oldCreateStoreBasePath,
  oldStoreDeactivatedPath,
  OLD_CHECKOUT_PAGE_PATHNAME,
  OLD_ORDER_CONFIRMATION_PAGE_PATHNAME,
  OLD_STORE_ACCESS_DENIED_PAGE,
  OLD_STORE_DEACTIVATED_PAGE,
  OLD_CART_PAGE_PATHNAME,
  OLD_STORE_BRAND_PAGE_PATHNAME,
  OLD_STORE_COLLECTION_PAGE_PATHNAME,
  OLD_MENU_ITEM_ROUTE,
  OLD_SEARCH_QUERY_PAGE_PATHNAME,
  OLD_MENU_PAGE_PATHNAME,
} from "@constants/old-routes";
import { getStoreSlugFromUrlWithWorkspace } from "@stadium/helpers/store";

export const SWAG_CREATION_SHOP_BASE_PATH = "/w/:workspaceSlug/design/swag";
export const ADD_SWAG_LOGO_PATHNAME = "/w/:workspaceSlug/design/swag/add-logo";
export const THEMED_COLLECTION_PATHNAME = "/w/:workspaceSlug/design/swag/themed-collection";

export const ALL_PRODUCTS = "all-products";
export const ALL_SUBCATEGORY_CODE = "all";

const storeBasePathWithoutCountryCode = "/w/:workspaceSlug/:storeCode";

const catalogBasePath = "/:countryCode-:lang/w/:workspaceSlug/:storeCode/catalog";

const createStoreBasePathWithoutCountryCode = "/w/:workspaceSlug/create/:storeCode";

const storeAccessDenied = "/w/:workspaceSlug/:storeCode/access-denied";

const storeBasePath = "/:countryCode-:lang/w/:workspaceSlug/:storeCode";
const createStoreBasePath = "/:countryCode-:lang/w/:workspaceSlug/create/:storeCode";
const storeDeactivatedPath = "/:countryCode-:lang/w/:workspaceSlug/:storeCode/deactivated-message";

export const cartRoute = ":storeBasePath/cart";
const menuRoute = ":storeBasePath/menu";

const allProductsRoute = `:storeBasePath/${ALL_PRODUCTS}`;

const menuItemRoute = ":storeBasePath/:category";
const searchItemsRoute = ":storeBasePath/search/:searchQuery";
const productRoute = ":storeBasePath/p/:productSlug";
const brandRoute = ":storeBasePath/brand/:brandSlug";
const storeRoute = ":storeBasePath";
export const LOGIN_CALLBACK_ROUTE = "/stores/auth0/login-callback";
export const checkoutRoute = ":storeBasePath/orders/:orderNumber/checkout";
const confirmationRoute = ":storeBasePath/orders/:orderNumber/confirmation";
export const HOME = "/";

// countryCode and lang below will al be renamed to localeCode and storeIdentifier respectively after new routes are made permanent

export const DETAILED_ORDER_REDEMPTION_PAGE_PATHNAME = "/[countryCode]-[lang]/orders/[inviteToken]";

export const OLD_ORDER_REDEMPTION_PAGE_PATHNAME_WITH_WORKSPACE =
  "/[countryCode]/[lang]/orders/[slug]/[inviteToken]";
export const ORDER_REDEMPTION_PAGE_PATHNAME_WITH_WORKSPACE =
  "/[countryCode]-[lang]/orders/[slug]/[inviteToken]";

const STORE_PATH_WITH_WORKSPACE = "/[countryCode]-[lang]/w/[workspaceSlug]/[storeIdentifier]";
export const NEW_STORE_HOME_PATH_WITH_WORKSPACE =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]";
export const NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE = "/[countryCode]/s/[storeIdentifier]";

export const HOME_PAGE_PATHNAME = "/[countryCode]-[lang]";
export const NEW_STORE_PATH_WITHOUT_WORKSPACE = "/[countryCode]-[lang]/s/[...others]";
export const NEW_STORE_PATH_WITH_WORKSPACE = "/[countryCode]-[lang]/w/[workspaceSlug]/[...others]";

export const STORE_HOME_PAGE_PATHNAME = NEW_STORE_HOME_PATH_WITH_WORKSPACE;
export const DETAILED_STORE_HOME_PAGE_PATHNAME = STORE_PATH_WITH_WORKSPACE;

export const STORE_INVITE_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/invite/[token]";
export const DETAILED_STORE_INVITE_PAGE_PATHNAME = `${STORE_PATH_WITH_WORKSPACE}/invite/[token]`;

export const STORE_MENU_PAGE_PATHNAME = "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/menu";
export const DETAILED_STORE_MENU_PAGE_PATHNAME = `${STORE_PATH_WITH_WORKSPACE}/menu`;

export const STORE_CREATE_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/create/[storeIdentifier]";
export const DETAILED_STORE_CREATE_PAGE_PATHNAME =
  "/[countryCode]-[lang]/w/[workspaceSlug]/create/[storeIdentifier]";

export const STORE_BRAND_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/brand/[brandSlug]";
export const STORE_BRAND_PAGE_PATHNAME_WITHOUT_WORKSPACE =
  "/[countryCode]/s/[storeIdentifier]/brand/[brandSlug]";

export const STORE_COLLECTION_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/collection/[menuIdentifier]";
export const STORE_COLLECTION_PAGE_PATHNAME_WITHOUT_WORKSPACE =
  "/[countryCode]/s/[storeIdentifier]/collection/[menuIdentifier]";
export const MAINTENANCE_PAGE_PATHNAME = "/maintenance";

export const MENU_ITEM_ROUTE = "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/menu/[menuItem]";
export const MENU_ITEM_ROUTE_WITHOUT_WORKSPACE =
  "/[countryCode]/s/[storeIdentifier]/menu/[menuItem]";

export const BASE_DEACTIVATED_PAGE = "/w/[workspaceSlug]/[storeIdentifier]/deactivated-message";

export const BASE_STORE_ACCESS_DENIED_PAGE = "/w/[workspaceSlug]/[storeIdentifier]/access-denied";

export const STORE_ACCESS_DENIED_PAGE = `/[countryCode]${BASE_STORE_ACCESS_DENIED_PAGE}`;
export const DETAILED_STORE_ACCESS_DENIED_PAGE = `/[countryCode]-[lang]${BASE_STORE_ACCESS_DENIED_PAGE}`;

export const STORE_DEACTIVATED_PAGE = `/[countryCode]${BASE_DEACTIVATED_PAGE}`;
export const DETAILED_STORE_DEACTIVATED_PAGE = `/[countryCode]-[lang]${BASE_DEACTIVATED_PAGE}`;

export const STORE_ORDER_CONFIRMATION_ROUTE = `${STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/confirmation`;
export const DETAILED_STORE_ORDER_CONFIRMATION_ROUTE = `${DETAILED_STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/confirmation`;

export const SEARCH_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/search`;
export const SEARCH_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/search`;

export const SEARCH_QUERY_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/search/[searchQuery]`;
export const SEARCH_QUERY_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/search/[searchQuery]`;

export const MENU_PAGE_PATHNAME_OLD = `${STORE_HOME_PAGE_PATHNAME}/[category]/[subCategory]`;
export const MENU_PAGE_PATHNAME_OLD_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/[category]/[subCategory]`;

export const MENU_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/[category]`;
export const MENU_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/[category]`;

export const CATALOG_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/catalog`;
export const CATALOG_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/catalog`;
export const CATALOG_ENTRIES_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/catalog/[categorySlug]`;
export const CATALOG_ENTRIES_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/catalog/[categorySlug]`;

export const HEADER_NAV_LINK_PATHNAME_PREFIX = "[countryCode]";

export const PRODUCT_VIEW_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;
export const PRODUCT_VIEW_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/p/[productSlug]`;
export const DETAILED_PRODUCT_VIEW_PATHNAME = `${DETAILED_STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;
export const DETAILED_PRODUCT_VIEW_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/p/[productSlug]`;

export const DETAILED_PRODUCT_VIEW_PATHNAME_WITH_WORKSPACE_SLUG = `${DETAILED_STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;

export const CART_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/cart`;
export const CART_PAGE_PATHNAME_WITHOUT_WORKSPACE = `${NEW_STORE_HOME_PATH_WITHOUT_WORKSPACE}/cart`;

export const CHECKOUT_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/checkout`;

export const ORDER_CONFIRMATION_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/confirmation`;

export const SWAG_CREATION_BASE_PATHNAME = "/w/[workspaceSlug]/design/swag";
export const SWAG_CREATION_BRAND_PAGE_PATHNAME = `${SWAG_CREATION_BASE_PATHNAME}/brand/[brandSlug]`;
export const SWAG_CREATION_ROUTE = `${SWAG_CREATION_BASE_PATHNAME}/[...others]`;

export const WITHOUT_MENU_PATHNAMES = [
  CHECKOUT_PAGE_PATHNAME,
  ORDER_CONFIRMATION_PAGE_PATHNAME,
  STORE_ACCESS_DENIED_PAGE,
  STORE_DEACTIVATED_PAGE,
  CART_PAGE_PATHNAME,
  OLD_CHECKOUT_PAGE_PATHNAME,
  OLD_ORDER_CONFIRMATION_PAGE_PATHNAME,
  OLD_STORE_ACCESS_DENIED_PAGE,
  OLD_STORE_DEACTIVATED_PAGE,
  OLD_CART_PAGE_PATHNAME,
];

/**
 * Paths where the menu header (category nav bar) SHOULD be visible.
 * Whitelist approach - menu only shows when path matches one of these.
 * Uses route constants for proper matching via matchesUrl.
 */
export const PATH_WITH_HEADER_MENU = [
  MENU_PAGE_PATHNAME,
  MENU_PAGE_PATHNAME_WITHOUT_WORKSPACE,
  MENU_PAGE_PATHNAME_OLD,
  MENU_PAGE_PATHNAME_OLD_WITHOUT_WORKSPACE,
  MENU_ITEM_ROUTE,
  MENU_ITEM_ROUTE_WITHOUT_WORKSPACE,
  STORE_BRAND_PAGE_PATHNAME,
  STORE_BRAND_PAGE_PATHNAME_WITHOUT_WORKSPACE,
  STORE_COLLECTION_PAGE_PATHNAME,
  STORE_COLLECTION_PAGE_PATHNAME_WITHOUT_WORKSPACE,
  SEARCH_QUERY_PAGE_PATHNAME,
  SEARCH_QUERY_PAGE_PATHNAME_WITHOUT_WORKSPACE,
  OLD_MENU_PAGE_PATHNAME,
  OLD_STORE_BRAND_PAGE_PATHNAME,
  OLD_STORE_COLLECTION_PAGE_PATHNAME,
  OLD_MENU_ITEM_ROUTE,
  OLD_SEARCH_QUERY_PAGE_PATHNAME,
  SWAG_CREATION_BRAND_PAGE_PATHNAME,
];

export const ALL_PRODUCTS_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/${ALL_PRODUCTS}/all`;

export const LOCKER_SHOP_CALCULATE_FULFILLMENT_FEE = `${removeTrailingSlash(
  SWAGMAGIC.url,
)}${getAQuote}?sourceOrigin=locker`;

export const OFFERINGS_PATH = "/go";
export const BOOK_A_CALL = `${OFFERINGS_PATH}/book-a-call`;

export const QUOTE_ESTIMATE_ROUTE = `${OFFERINGS_PATH}/heres-your-estimate`;
export const GET_A_QUOTE_ROUTE = `${OFFERINGS_PATH}/get-a-quote`;

export const getCartRoute = ({ storeBasePath }) => {
  return cartRoute.replace(":storeBasePath", storeBasePath);
};

export const getMenuRoute = ({ storeBasePath }) => {
  return menuRoute.replace(":storeBasePath", storeBasePath);
};

export const getAllProductPageRoute = ({ storeBasePath, query = {} }) => {
  return { pathname: allProductsRoute.replace(":storeBasePath", storeBasePath), query };
};

export const getCheckoutRoute = ({ storeBasePath, orderNumber }) => {
  return checkoutRoute
    .replace(":storeBasePath", storeBasePath)
    .replace(":orderNumber", orderNumber);
};

export const getConfirmationRoute = ({ orderNumber, storeBasePath }) => {
  return confirmationRoute
    .replace(":storeBasePath", storeBasePath)
    .replace(":orderNumber", orderNumber);
};

export const getMenuItemRoute = ({ storeBasePath, category, query = {} }) => {
  return {
    pathname: menuItemRoute.replace(":storeBasePath", storeBasePath).replace(":category", category),
    query,
  };
};

export const getSearchItemsRoute = ({ storeBasePath, searchQuery }) => {
  return searchItemsRoute
    .replace(":storeBasePath", storeBasePath)
    .replace(":searchQuery", searchQuery);
};

export const getBrandRoute = ({ storeBasePath, brandSlug }) => {
  return brandRoute.replace(":brandSlug", brandSlug).replace(":storeBasePath", storeBasePath);
};

export const getProductRoute = ({
  storeBasePath,
  productSlug,
  editProductIds = "",
  broken = false,
  brokenVariantId = "",
}) => {
  const getBrokenProductVariantId = (brokenVariantId = "") => {
    if (brokenVariantId) {
      const splittedArray = brokenVariantId.split("_");
      return splittedArray[1];
    }
    return "";
  };

  const variantId = broken ? getBrokenProductVariantId(brokenVariantId) : "";
  const path = productRoute
    .replace(":productSlug", productSlug)
    .replace(":storeBasePath", storeBasePath);
  if (editProductIds) return `${path}?editProductIds=${editProductIds}`;
  if (variantId) return `${path}?variantId=${variantId}`;
  return path;
};

export const getStoreHomeRoute = ({ storeBasePath }) => {
  return storeRoute.replace(":storeBasePath", storeBasePath);
};

export const getNewShopCreationRoute = ({
  countryCode,
  lang,
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) =>
  `${getStoreBasePath({
    countryCode,
    lang,
    storeCode,
    storeNumber,
    workspaceSlug,
    isNewShopCreationFlow: true,
    isNewRoute,
  })}?createShop=true`;

export const getStorePreviewPath = ({ storeBasePath }) => {
  return getPreviewTemplateRoute(getStoreHomeRoute({ storeBasePath }));
};

export const getStoreBasePathWithoutCountryCode = ({
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) => {
  const finalStoreBasePathWithoutCountryCode = isNewRoute
    ? storeBasePathWithoutCountryCode
    : oldStoreBasePathWithoutCountryCode;
  const result = finalStoreBasePathWithoutCountryCode
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  return isNewRoute ? canonicalizeMySpacePath(result) : result;
};

export const getCreateStoreBasePathWithoutCountryCode = ({
  storeCode = DEFAULT_BYO_SHOP_CODE,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  returnTo = null,
  isNewRoute = false,
}) => {
  const params = new URLSearchParams({
    createShop: true,
    ...(returnTo && { returnTo }),
  });

  const finalCreateStoreBasePathWithoutCountryCode = isNewRoute
    ? createStoreBasePathWithoutCountryCode
    : oldCreateStoreBasePathWithoutCountryCode;

  const path = finalCreateStoreBasePathWithoutCountryCode
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  const canonicalPath = isNewRoute ? canonicalizeMySpacePath(path) : path;
  return `${canonicalPath}?${params}`;
};

export const getStoreDeactivatedRoute = ({
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) => {
  const finalStoreDeactivatedPath = isNewRoute ? storeDeactivatedPath : oldStoreDeactivatedPath;
  const result = finalStoreDeactivatedPath
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  return isNewRoute ? canonicalizeMySpacePath(result) : result;
};

export const getStoreBasePath = ({
  countryCode,
  lang,
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewShopCreationFlow = false,
  isSwagCreationShopFlow = false,
  isNewRoute = false,
}) => {
  if (isSwagCreationShopFlow) {
    // Swag-creation lives under /w/[workspaceSlug]/design/swag and is intentionally
    // workspace-bound (no /s/ short form), so we deliberately skip canonicalization here.
    return SWAG_CREATION_SHOP_BASE_PATH.replace(":workspaceSlug", workspaceSlug);
  }
  const finalStoreBasePath = isNewRoute ? storeBasePath : oldStoreBasePath;
  const finalCreateStoreBasePath = isNewRoute ? createStoreBasePath : oldCreateStoreBasePath;
  const basePath = isNewShopCreationFlow ? finalCreateStoreBasePath : finalStoreBasePath;
  const result = basePath
    .replace(":countryCode", countryCode)
    .replace(":lang", lang)
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  return isNewRoute ? canonicalizeMySpacePath(result) : result;
};

export const getCatalogBasePath = ({
  countryCode,
  lang,
  storeCode,
  workspaceSlug = MY_WORKSPACE_SLUG,
}) => {
  const result = catalogBasePath
    .replace(":countryCode", countryCode)
    .replace(":lang", lang)
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode);
  return canonicalizeMySpacePath(result);
};

export const getStoreBaseWithCountryPathKey = ({
  lang,
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) => {
  const finalStoreBasePath = isNewRoute ? storeBasePath : oldStoreBasePath;
  const result = finalStoreBasePath
    .replace(":lang", lang)
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  // Result still contains the literal `:countryCode` placeholder; consumers fill it in
  // at runtime to produce the final URL, so canonicalize the my-space segment now.
  return isNewRoute ? canonicalizeMySpacePath(result) : result;
};

export const getStoreAccessDeniedRoute = ({
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) => {
  const finalStoreAccessDenied = isNewRoute ? storeAccessDenied : oldStoreAccessDenied;
  const result = finalStoreAccessDenied
    .replace(":workspaceSlug", workspaceSlug)
    .replace(":storeCode", storeCode)
    .replace(":storeNumber", storeNumber);
  return isNewRoute ? canonicalizeMySpacePath(result) : result;
};

export const getStoreDetailPageRoute = ({ storeCode }) => {
  return `${SHOPS_DETAIL_MARKETING_PAGE}/${storeCode}`;
};

export const getPreviewTemplateRoute = (storeUrl) => `${storeUrl}?preview=true`;

export const getPublishStoreRoute = ({
  dummyStoreNumber,
  countryCode,
  lang,
  storeCode,
  storeNumber,
  workspaceSlug = MY_WORKSPACE_SLUG,
  isNewRoute = false,
}) =>
  `${getStoreBasePath({
    countryCode,
    lang,
    storeCode,
    storeNumber,
    workspaceSlug,
    isNewRoute,
  })}/create/${dummyStoreNumber}`;

export const getGuestWorkspacePathFromStore = ({ storeRoute, isNewRoute = false, slug = "" }) => {
  const path = storeRoute ?? "";
  const isStorePath = ["/stores/", "/s/"].some((fragment) => path.includes(fragment));

  if (!slug || !isStorePath) return path;

  if (isNewRoute) {
    return path.replace("/s/", `/w/${DEFAULT_WORKSPACE_SLUG}/`);
  }

  const slugWithoutWorkspace = getStoreSlugFromUrlWithWorkspace(slug);

  if (slugWithoutWorkspace !== slug) {
    return path;
  }

  return path.replace(`/${slug}`, `/${slug}--${DEFAULT_WORKSPACE_SLUG}`);
};

export const GO_CATALOG_PATHNAME = "/go/catalog";
export const MEGA_SHOP_CATALOG_PATHNAME = "/go/catalogs";
export const PRICING_PATHNAME = "/go/pricing";
export const BOOK_A_CALL_PATHNAME = "/go/book-a-call";
export const INVITE_TOKEN_UUID_SEPERATOR = "--";

export const META_QUERY_PARAM_KEY = "meta";
